import React, { useEffect, useState } from 'react';
import PrimaryBtn from 'components/btns/PrimaryBtn';
import { VEHICLE_COLUMNS } from 'helper/data';

import { BasicTable } from 'components/BasicTable/BasicTable';
import AddVehicle from 'modals/vehicles/AddVehicle';
import useApiHook from 'hooks/useApiHook';
import Spiner from 'helper/Spiner';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

const Vehicles = () => {
  const { auth } = useSelector((state) => state);
  const [addVehicleModal, setIsaddVehicleModal] = useState(false);
  const { handleApiCall, isApiLoading } = useApiHook();
  const [vehicles, setVehicles] = useState([]);
  const [count, setCount] = useState();
  const [page, setPage] = useState(1);
  const [pageCount, setPageCount] = useState(10);
  const [_, setSelectedVehicle] = useState({});
  const [firstLoad, setFirstLoad] = useState(true);
  const navigate = useNavigate();

  const getAllVehicles = async () => {
    const result = await handleApiCall({
      method: 'get',
      url: `/admin/vehicle/all?page=${page}&pageSize=${pageCount}`,
    });

    if (result.status === 200) {
      setVehicles(result?.data?.vehicles);
      setCount(result?.data?.count);
      setFirstLoad(false);
    }
  };

  useEffect(() => {
    if (!auth?.isLogin) navigate('/login');
    else getAllVehicles();
  }, [page, pageCount]);

  return (
    <div className='ez__Home w-full relative z-1 p-5 pb-10'>
      <div className='flex flex-row justify-between items-center'>
        <h1 className='text-2xl font-semibold text-ezBlack'>Vehicles</h1>
        {/* <PrimaryBtn
          btnType='submit'
          text='Add Vehicle'
          width
          handleEvent={() => setIsaddVehicleModal(true)}
        /> */}
      </div>
      {firstLoad && isApiLoading && (
        <div className='col-span-3 block w-full h-96'>
          <Spiner color='ezGreen' />
        </div>
      )}
      {!firstLoad && (
        <div className=' w-full block card bg-white rounded-md shadow-sm  border'>
          <BasicTable
            COLUMNS={VEHICLE_COLUMNS}
            ROWS={vehicles}
            paginationText='Vehicles'
            isApiLoading={isApiLoading}
            view='vehicles'
            searchText='Search vehicle'
            setSelectedValue={setSelectedVehicle}
            pageNumber={page}
            setPageNumber={setPage}
            pageCount={pageCount}
            setPageCount={setPageCount}
            totalCount={count}
          />
        </div>
      )}
      {addVehicleModal && (
        <AddVehicle
          isVehicleModal={addVehicleModal}
          setIsVehicleModal={setIsaddVehicleModal}
        />
      )}{' '}
    </div>
  );
};

export default Vehicles;